import React, {useEffect, useState} from 'react'
import ViberIcon from '../../../../../../../../assets/icons/platforms/ViberIcon'
import config from "../../../../../../../../config";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import Translate from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import {addViberBot, deleteViberBot} from "../../../../../../../../services/integrations/api";
import colors from "../../../../../../../../utils/Colors";
import Accordion from "../../../../../../../../components-new/ui/Accordion";
import AccordionItem from "../../../../../../../../components-new/ui/Accordion/AccordionItem";
import CircleQuestionMarkIcon from "../../../../../../../../assets/icons/CircleQuestionMarkIcon";
import MinusIcon from "../../../../../../../../assets/icons/MinusIcon";
import PlusIcon from "../../../../../../../../assets/icons/PlusIcon";
import FileUpload from "../../../../../../../../components-new/general/FileUpload";

export const Viber = ({
                          client,
                          viberBot,
                          setViberBot,
                          addNotification,
                          user
                      }) => {

    const [botSnapshot, setBotSnapshot] = useState(null)

    useEffect(() => {
        if (viberBot.fetched && botSnapshot == null) {
            setBotSnapshot({...viberBot})
        }
    }, [viberBot])

    const handleDeleteViberBot = async () => {
        try {
            await deleteViberBot(client.id)
            setBotSnapshot(null)
            setViberBot({
                token: "",
                name: "",
                avatar: "",
                attached: false,
                fetched: true
            })
            addNotification("deleted", config.notificationLevels.success)
        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        }
    }

    const handleViberBotSave = async () => {
        try {
            const response = await addViberBot({
                token: viberBot.token,
                name: viberBot.name,
                avatar: viberBot.avatar
            }, client.id)

            if (response.success) {
                setBotSnapshot(null)
                setViberBot({
                    attached: true,
                    fetched: true,
                    ...response
                })
                addNotification("added", config.notificationLevels.success)
                return
            }
            throw new Error()

        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        }
    }


    return (
        <div className="bg-white" style={{
            minHeight: 'auto',
            height: 'fit-content',
            maxHeight: '65vh',
            overflow: 'auto',
        }}>
            <div style={{
                width: '100%',
                height: '100%',
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                }}>
                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <ViberIcon width={40} height={40} style={{marginRight: '15px'}}/>
                            <h2>Viber</h2>
                        </div>
                    </div>

                    <Accordion
                        defaultValue={viberBot.attached ? null : '1'}
                        style={{
                            margin: '10px 0'
                        }}
                    >
                        <AccordionItem
                            value="1"
                            triggerContent={
                                <span className="integration-steps">
                                <CircleQuestionMarkIcon/>
                                <Translate text="integrationSteps"/>
                            </span>
                            }
                            triggerIcon={({isOpen}) => {
                                return isOpen() ? <MinusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/> :
                                    <PlusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/>
                            }}
                            itemStyle={{
                                background: '#fafafa',
                                borderRadius: '10px',
                                padding: '12px 16px'
                            }}
                        >
                            <div style={{
                                padding: '10px 0 10px 34px',
                                textAlign: 'justify',
                                userSelect: 'text',
                            }}>
                                {user.language === 'en' ?
                                    <ol style={{paddingLeft: '20px', margin: 0}}>
                                        <li style={{marginBottom: '10px'}}>
                                            Apply for a <b>Viber Bot</b> on Viber official <a style={{color: 'var(--ds-text-primary)'}}
                                                                                              href="https://www.forbusiness.viber.com/en/viber-for-business/#form_f2068195-d9a1-43a2-bd10-e4a6372fbec7"
                                                                                              target="_blank">website</a>.
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            In the bot dashboard, you will find your <b>Token</b>.
                                            Copy this value and paste it below.
                                        </li>

                                        <li>
                                            Save the token in this form and complete the setup.
                                            Once attached, incoming messages will be delivered to your webhook.
                                        </li>
                                    </ol>
                                    :
                                    <ol style={{paddingLeft: '20px', margin: 0}}>
                                        <li style={{marginBottom: '10px'}}>
                                            Ներկայացրեք <b>Viber Bot</b> ստեղծման դիմում Viber ֊ ի <a
                                            style={{color: 'var(--ds-text-primary)'}}
                                            href="https://www.forbusiness.viber.com/en/viber-for-business/#form_f2068195-d9a1-43a2-bd10-e4a6372fbec7"
                                            target="_blank">պաշտոնական կայքում</a>:
                                        </li>

                                        <li style={{marginBottom: '10px'}}>
                                            Բոթի վահանակում կգտնեք ձեր <b>Token</b>-ը:
                                            Պատճենեք այս տվյալը և տեղադրեք ստորև:
                                        </li>

                                        <li>
                                            Պահպանեք թոքենը այս ձևում և ավարտեք կարգավորումը:
                                            Կցվելուց հետո մուտքային հաղորդագրությունները կուղարկվեն ձեր webhook հասցեին։
                                        </li>
                                    </ol>
                                }

                            </div>

                        </AccordionItem>
                    </Accordion>

                    {viberBot.attached && (
                        <div className="whatsapp-bot-div">
                            <span>Viber Attached</span>
                            <span onClick={handleDeleteViberBot}
                                  className="whatsapp-bot-delete-button">&times;</span>
                        </div>
                    )}

                    <FileUpload
                        windowSize={120}
                        imgSize={110}
                        svgSize={50}
                        progressSize={120}
                        handleChange={(v) => setViberBot({...viberBot, avatar: v})}
                        handleDelete={() => setViberBot({...viberBot, avatar: null})}
                        image={viberBot.avatar}
                        style={{minWidth: 0, flexShrink: 0, marginBottom: '10px'}}
                    />

                    {viberBot.attached &&
                        <span style={{margin: '6px', fontWeight: 'bold', display: 'inline-block'}}>Bot Name</span>}
                    <Input
                        value={viberBot.name ? viberBot.name : ""}
                        type="text"
                        name="name"
                        placeholder="Bot name"
                        onChange={e => {
                            const value = e.target.value;
                            setViberBot(prev => {
                                    return {
                                        ...prev,
                                        name: value ? value : null
                                    }
                                }
                            )
                        }
                        }
                        style={{marginBottom: '10px'}}
                    />

                    {viberBot.attached &&
                        <span style={{margin: '6px', fontWeight: 'bold', display: 'inline-block'}}>Access Token</span>}
                    <Input
                        value={viberBot.token ? viberBot.token : ""}
                        type="text"
                        name="token"
                        placeholder="Access Token"
                        onChange={e => {
                            const value = e.target.value;
                            setViberBot(prev => {
                                    return {
                                        ...prev,
                                        token: value
                                    }
                                }
                            )
                        }
                        }
                        disabled={!!viberBot.attached}
                    />

                    <div style={{display: 'flex', justifyContent: 'end',}}>
                        <BlueButton
                            styles={{marginTop: '20px'}}
                            disabled={(!viberBot.token || (botSnapshot && viberBot.name === botSnapshot.name && viberBot.avatar === botSnapshot.avatar))}
                            onClick={handleViberBotSave}
                            width={'135px'}
                            children={<Translate text={'save'}/>}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/Viber.jsx